import { envFlags, FLAGS } from '@thoughtspot/env-flags';
import { jsonConstants } from '@thoughtspot/json-constants';
import _ from 'lodash';
let systemConfig = {};
const SAML_ENABLED_KEY = 'samlEnabled';
const OIDC_ENABLED_KEY = 'oidcEnabled';
const EXTERNAL_AUTH_KEY = 'externalAuth';
const OIDC_REDIRECT_KEY = 'oidcLoginPageRedirect';
const OIDC_URI_KEY = 'oidcLoginUri';
const OKTA_ENABLED_KEY = 'oktaEnabled';
const SLACK_CONFIGURATION_KEY = 'slackConfiguration';
const CLUSTERID_KEY = 'ClusterId';
const CLUSTERNAME_KEY = 'ClusterName';
const ADMINEMAIL_KEY = 'adminEmail';
const CLIENT_ID = 'clientId';
const IDP_DOMAIN = 'idpDomain';
export const IS_AUTHENTICATION_DONE = 'isAuthenticationDone';
export const IS_AUTHENTICATION_DONE_FLAG_TTL = 5 * 60 * 1000;
export const REDIRECT_URI = 'redirect_uri';
export var Issuers;
(function (Issuers) {
    Issuers["GOOGLE"] = "google";
    Issuers["MICROSOFT"] = "microsoft";
})(Issuers || (Issuers = {}));
export const DEFAULT_MIXPANEL_CONFIG = {
    apiHostEnabled: false,
    apiHost: '',
    clusterId: 'local',
    devSdkKey: '',
    enabled: false,
    prodSdkKey: '',
    production: false,
    enableCrossSubDomainCookie: true,
    useLocalStorageForPersistence: false,
};
export function setSystemConfig(config) {
    systemConfig = config;
}
export function setMixpanelConfig(mixpanelConfig) {
    systemConfig[jsonConstants.MIXPANEL_CONFIG] = mixpanelConfig;
}
export function isSamlEnabled() {
    return _.get(systemConfig, SAML_ENABLED_KEY, false);
}
export const isURLFlagsDisabled = () => {
    return _.get(systemConfig, jsonConstants.URL_FLAGS_DISABLED, false);
};
export const disableSAMLAutoRedirect = () => {
    if (isURLFlagsDisabled()) {
        return false;
    }
    return !!envFlags.getValue(FLAGS.disableSAMLAutoRedirect?.name);
};
export const disableOIDCAutoRedirect = () => {
    if (isURLFlagsDisabled()) {
        return false;
    }
    return !!envFlags.getValue(FLAGS.disableOIDCAutoRedirect?.name);
};
export const getShouldStopRedirecitonOnManualLogout = () => {
    return _.get(systemConfig, jsonConstants.SHOULD_STOP_REDIRECTION_ON_MANUAL_LOGOUT, true);
};
export const getFreeTrialV2ExperienceEnabled = () => {
    return _.get(systemConfig, jsonConstants.ENABLE_FREE_TRIAL_V2_EXPERIENCE, false);
};
export function isOidcEnabled() {
    return _.get(systemConfig, OIDC_ENABLED_KEY, false);
}
export function isExternalAuth() {
    return _.get(systemConfig, EXTERNAL_AUTH_KEY, false);
}
export function isOktaEnabled() {
    return _.get(systemConfig, OKTA_ENABLED_KEY, false);
}
export function isOidcRedirect() {
    return _.get(systemConfig, OIDC_REDIRECT_KEY, false);
}
export function getOidcLoginUri() {
    return _.get(systemConfig, OIDC_URI_KEY, null);
}
export function getSlackConfig() {
    return _.get(systemConfig, SLACK_CONFIGURATION_KEY, null);
}
export function autoRedirectToSamlLogin() {
    return _.get(systemConfig, jsonConstants.samlConfig.SAML_LOGIN_PAGE_REDIRECT, false);
}
export function isLogoutEnabled() {
    return _.get(systemConfig, jsonConstants.samlConfig.LOGOUT_ENABLED, false);
}
export const isResetPasswordEnabled = () => {
    return _.get(systemConfig, jsonConstants.RESET_PASSWORD_ENABLED, false);
};
export const isLocalizationEnabled = function () {
    return (!!envFlags.getValue(FLAGS.locale?.name) ||
        _.get(systemConfig, jsonConstants.ENABLE_LOCALIZATION, false));
};
export const shouldUseGetEncoding = () => {
    return (!!envFlags.getValue(FLAGS.shouldUseGetEncoding.name) ||
        _.get(systemConfig, jsonConstants.USE_GET_ENCODING, false));
};
export const isSignUpEnabled = () => {
    if (_.isUndefined(systemConfig[jsonConstants.ENABLE_SIGNUP_BTN])) {
        return !!envFlags.getValue(FLAGS.signUpEnabled.name);
    }
    if (!_.isNull(envFlags.getValue(FLAGS.signUpEnabled.name))) {
        return !!envFlags.getValue(FLAGS.signUpEnabled.name);
    }
    return systemConfig[jsonConstants.ENABLE_SIGNUP_BTN];
};
export const getSignUpBtnText = () => {
    if (_.isUndefined(systemConfig[jsonConstants.ENABLE_SIGNUP_BTN])) {
        return envFlags.getValue(FLAGS.signUpButtonText.name);
    }
    if (!_.isNull(envFlags.getValue(FLAGS.signUpButtonText.name))) {
        return envFlags.getValue(FLAGS.signUpButtonText.name);
    }
    return systemConfig[jsonConstants.SIGNUP_BTN_TEXT];
};
export const getSignUpBtnLink = () => {
    if (_.isUndefined(systemConfig[jsonConstants.ENABLE_SIGNUP_BTN])) {
        return envFlags.getValue(FLAGS.signUpButtonLink.name);
    }
    if (!_.isNull(envFlags.getValue(FLAGS.signUpButtonLink.name))) {
        return envFlags.getValue(FLAGS.signUpButtonLink.name);
    }
    return systemConfig[jsonConstants.SIGNUP_BTN_LINK];
};
export const isCustomBrandingEnabled = () => {
    if (!systemConfig || !systemConfig[jsonConstants.CUSTOM_BRANDING_ENABLED]) {
        return false;
    }
    return systemConfig[jsonConstants.CUSTOM_BRANDING_ENABLED];
};
export const isIntercomEnabled = () => {
    if (!_.isUndefined(envFlags.getValue(FLAGS.intercomEnabled.name))) {
        return !!envFlags.getValue(FLAGS.intercomEnabled.name);
    }
    return !!systemConfig[jsonConstants.INTERCOM_ENABLED];
};
export const clusterId = () => {
    return systemConfig[CLUSTERID_KEY];
};
export const clusterName = () => {
    return systemConfig[CLUSTERNAME_KEY];
};
export const getAdminEmail = () => {
    if (!systemConfig || !systemConfig[ADMINEMAIL_KEY]) {
        return '';
    }
    return systemConfig[ADMINEMAIL_KEY];
};
export const isEmbeddedUseCase = () => {
    if (!systemConfig ||
        !systemConfig.hasOwnProperty(jsonConstants.IS_EMBEDDED_USECASE)) {
        return false;
    }
    return systemConfig[jsonConstants.IS_EMBEDDED_USECASE];
};
export const getSupportEmail = () => {
    if (!systemConfig ||
        !systemConfig.hasOwnProperty(jsonConstants.SUPOORT_EMAIL)) {
        return '';
    }
    return systemConfig[jsonConstants.SUPOORT_EMAIL];
};
export const getPublicUserName = () => {
    if (!systemConfig ||
        !systemConfig[jsonConstants.IS_PUBLIC_USER] ||
        !systemConfig[jsonConstants.PUBLIC_USER_NAME]) {
        return null;
    }
    return systemConfig[jsonConstants.PUBLIC_USER_NAME];
};
export const isPublicUserEnabled = () => {
    if (!systemConfig || !systemConfig[jsonConstants.IS_PUBLIC_USER]) {
        return false;
    }
    return systemConfig[jsonConstants.IS_PUBLIC_USER];
};
export const isPendoEnabled = () => {
    if (!systemConfig ||
        !systemConfig.hasOwnProperty(jsonConstants.ENABLE_PENDO)) {
        return false;
    }
    return systemConfig[jsonConstants.ENABLE_PENDO];
};
export const hideDocsInDevelop = () => {
    if (!systemConfig ||
        !systemConfig.hasOwnProperty(jsonConstants.DOC_HIDDEN_DEVELOP_TAB)) {
        return false;
    }
    return systemConfig[jsonConstants.DOC_HIDDEN_DEVELOP_TAB];
};
export const isLicensed = () => {
    return !!systemConfig.licensed;
};
export const isFreeTrialActivationEnabled = () => {
    if (!systemConfig ||
        !systemConfig.hasOwnProperty(jsonConstants.FREE_TRIAL_ACTIVATION_SCREEN_ENABLED)) {
        return false;
    }
    return systemConfig[jsonConstants.FREE_TRIAL_ACTIVATION_SCREEN_ENABLED];
};
export const isDeepLinkingDisabled = () => {
    if (!systemConfig ||
        !systemConfig.hasOwnProperty(jsonConstants.DISABLE_MOBILE_DEEP_LINK)) {
        return false;
    }
    return systemConfig[jsonConstants.DISABLE_MOBILE_DEEP_LINK];
};
export const showLoginWithUserEmail = () => {
    if (!systemConfig ||
        !systemConfig.hasOwnProperty(jsonConstants.SHOW_LOGIN_WITH_USER_EMAIL)) {
        return false;
    }
    return systemConfig[jsonConstants.SHOW_LOGIN_WITH_USER_EMAIL];
};
export const getClientId = () => {
    if (!systemConfig || !systemConfig[CLIENT_ID]) {
        return '';
    }
    return systemConfig[CLIENT_ID];
};
export const getIdpDomain = () => {
    if (!systemConfig || !systemConfig[IDP_DOMAIN]) {
        return '';
    }
    return systemConfig[IDP_DOMAIN];
};
export const dataWorkspaceConfig = () => {
    if (!systemConfig ||
        !systemConfig.hasOwnProperty(jsonConstants.DATA_WORKSPACE_CONFIG)) {
        return null;
    }
    if (systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG].enabled &&
        (systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG].dataAppV2Enabled ||
            !!envFlags.getValue(FLAGS.enableDataAppV2.name))) {
        return {
            enabled: true,
            dataAppV2Enabled: true,
            sqlEditorEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .sqlEditorEnabled ||
                !!envFlags.getValue(FLAGS.enableSQLEditor.name),
            spotAppsEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .spotAppEnabled ||
                !!envFlags.getValue(FLAGS.enableSpotApps.name),
            tsSyncEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .tsSyncEnabled ||
                !!envFlags.getValue(FLAGS.enableDataPipeline.name),
            answersSyncEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .answersSyncEnabled,
            slackEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG].slackEnabled,
            dbtMetricsEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .dbtMetricsEnabled,
            googleBigQueryEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .googleBigQueryEnabled,
            googleSheetsEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .googleSheetsEnabled,
            salesForceEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .salesForceEnabled,
            msExcelEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .msExcelEnabled,
            msTeamsEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .msTeamsEnabled,
            mailchimpEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .mailchimpEnabled,
            gatingForSyncEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .gatingForSyncEnabled,
            fullImageSyncEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .fullImageSyncEnabled,
            dataCatalogAtlanEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .dataCatalogAtlanEnabled,
            dataCatalogCollibraEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .dataCatalogCollibraEnabled,
            dataAugmentationEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .dataAugmentationEnabled,
            snowflakeEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .snowflakeEnabled,
            redshiftEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .redshiftEnabled,
            dataCatalogEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .dataCatalogEnabled,
            verifyLiveboardEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .verifyLiveboardEnabled,
            verifyLiveboardPrivilegeEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .verifyLiveboardPrivilegeEnabled,
            hubSpotEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .hubSpotEnabled,
            zohoEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG].zohoEnabled,
            zendeskEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .zendeskEnabled,
            dbtIntegrationEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .dbtIntEnabled ||
                !!envFlags.getValue(FLAGS.enableDbtInt.name),
            createSpotAppEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .createSpotAppEnabled,
            spotAppAdminEnabled: !!envFlags.getValue(FLAGS.enableSpotAppsAdminForE2E.name),
            tsSyncScheduleEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .tsSyncScheduleEnabled,
            serviceNowEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .serviceNowEnabled,
            gainsightEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG]
                .gainsightEnabled,
            webexEnabled: systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG].webexEnabled,
        };
    }
    systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG].enabled = false;
    return systemConfig[jsonConstants.DATA_WORKSPACE_CONFIG];
};
export const getGoogleSignInLink = () => {
    if (!systemConfig ||
        !systemConfig.hasOwnProperty(jsonConstants.ISSUERS) ||
        _.isEmpty(systemConfig[jsonConstants.ISSUERS])) {
        return '';
    }
    const link = systemConfig[jsonConstants.ISSUERS].find((issuer) => issuer.indexOf(Issuers.GOOGLE) >= 0);
    return link || '';
};
export const getOidcLoginUriFromIssuers = () => {
    if (!systemConfig ||
        !systemConfig.hasOwnProperty(jsonConstants.ISSUERS) ||
        _.isEmpty(systemConfig[jsonConstants.ISSUERS])) {
        return '';
    }
    const link = systemConfig[jsonConstants.ISSUERS][0];
    return link || '';
};
export const getIdentityServicePublicUrl = () => {
    if (!systemConfig ||
        !systemConfig[jsonConstants.IDENTITY_SERVICE_PUBLIC_URL]) {
        return '';
    }
    return systemConfig[jsonConstants.IDENTITY_SERVICE_PUBLIC_URL];
};
export const getMixpanelConfig = () => {
    const enableCrossSubDomainCookieFlag = envFlags.getValue(FLAGS.enableCrossSubDomainCookie?.name);
    const useLocalStorageForPersistence = envFlags.getValue(FLAGS.useLocalStorageForMixpanel?.name);
    let config = systemConfig?.[jsonConstants.MIXPANEL_CONFIG];
    if (!config || _.isEmpty(systemConfig[jsonConstants.MIXPANEL_CONFIG])) {
        config = DEFAULT_MIXPANEL_CONFIG;
    }
    if (!_.isUndefined(enableCrossSubDomainCookieFlag)) {
        config.enableCrossSubDomainCookie = enableCrossSubDomainCookieFlag;
    }
    if (!_.isUndefined(useLocalStorageForPersistence)) {
        config.useLocalStorageForPersistence = useLocalStorageForPersistence;
    }
    return config;
};
export const isMixpanelEnabled = (_configInfo) => {
    const mixpanelConfig = _configInfo[jsonConstants.MIXPANEL_CONFIG];
    if (!mixpanelConfig) {
        return false;
    }
    return mixpanelConfig.enabled;
};
export const getMixpanelAccessToken = () => {
    const mixpanelConfig = getMixpanelConfig();
    if (!mixpanelConfig || !mixpanelConfig.enabled) {
        return '';
    }
    return mixpanelConfig.production
        ? mixpanelConfig.prodSdkKey
        : mixpanelConfig.devSdkKey;
};
export const checkIfMixpanelAPIHostEnabledAndReturn = () => {
    const mixpanelConfig = getMixpanelConfig();
    if (!mixpanelConfig || !mixpanelConfig.enabled) {
        return '';
    }
    if (!mixpanelConfig.apiHostEnabled) {
        return '';
    }
    return mixpanelConfig.apiHost;
};
export const isLoginRedirectDisabled = () => {
    return !!envFlags.getValue(FLAGS.disableLoginRedirect?.name);
};
export function setSessionStorageWithExpiry(key, value, ttl) {
    const now = new Date();
    const expiryTime = now.getTime() + ttl;
    const item = {
        value,
        expiry: expiryTime,
    };
    sessionStorage.setItem(key, JSON.stringify(item));
}
export function getSessionStorageItem(key) {
    const itemStr = sessionStorage.getItem(key);
    if (!itemStr) {
        return null;
    }
    let item;
    try {
        item = JSON.parse(itemStr);
    }
    catch {
        return null;
    }
    const now = new Date().getTime();
    if (!item.expiry || now > item.expiry) {
        sessionStorage.removeItem(key);
        return null;
    }
    return item.value;
}
//# sourceMappingURL=system-config-service.js.map